import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { adminApi, errMsg } from "@/lib/api";
import { cn } from "@/lib/utils";
import { toast } from "sonner";

const OPTS = [["default", "Regra geral"], ["custom", "Prazo próprio"], ["exempt", "Isento"]];
const HINT = {
  default: "Segue a regra de Parâmetros.",
  custom: "Prazo só para este cliente, mesmo se a regra geral estiver desligada.",
  exempt: "Este cliente nunca é bloqueado automaticamente por atraso.",
};

export function OverdueRuleBox({ tenant, onSaved }) {
  const [mode, setMode] = useState(tenant.overdue_rule?.mode || "default");
  const [days, setDays] = useState(String(tenant.overdue_rule?.days ?? 5));
  const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true);
    try {
      await adminApi.put(`/tenants/${tenant.id}/overdue-rule`, { mode, days: Number(days) || 0 });
      toast.success("Regra de atraso salva");
      onSaved();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div className="space-y-2 border-t pt-4" data-testid="overdue-rule-box">
      <p className="font-semibold">Bloqueio por pagamento em atraso</p>
      <div className="grid grid-cols-3 gap-1.5">
        {OPTS.map(([v, l]) => (
          <button key={v} type="button" onClick={() => setMode(v)} className={cn("rounded-lg border px-2 py-2 text-xs transition-colors", mode === v ? "border-primary bg-primary/5 font-semibold" : "hover:bg-muted")} data-testid={`overdue-mode-${v}`}>{l}</button>
        ))}
      </div>
      {mode === "custom" && (
        <label className="flex items-center gap-2 text-sm">Bloquear após
          <Input type="number" min={0} value={days} onChange={(e) => setDays(e.target.value)} className="h-8 w-20" data-testid="overdue-days-input" />dias de atraso
        </label>
      )}
      <p className="text-xs text-muted-foreground">{HINT[mode]}</p>
      <Button size="sm" variant="outline" onClick={save} disabled={busy} data-testid="overdue-rule-save">Salvar regra</Button>
    </div>
  );
}
